import React from 'react';
import { Container, Grid } from '@mui/material';
import styled from 'styled-components';

import FAQQuestions from './FAQQuestions';
import { FAQItem } from './FAQItem';
import { Title } from '../Common/Title';

const FAQContainer = styled.section`
  background-color: var(--white);
  padding: 4rem 0;
`;

export const FAQ = () => {
  return (
    <FAQContainer>
      <Container>
        <Grid container spacing={1}>
          <Grid item sm={12} xs={12} align="center">
            <Title>Perguntas frequentes</Title>
            <Grid item sm={1} />
            <Grid item sm={10}>
            {FAQQuestions.map((q) => (
              <FAQItem
                key={Math.random()}
                title={q.title}
                content={q.content}
                isTable={q.isTable}
                headers={q.headers}
                data={q.data}
              />
            ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </FAQContainer>
  )
}